import React from 'react'
import PropTypes from 'prop-types'

import Button from '../Button/Button'
import CartButton from '../CartButton/CartButton'
import Dollars from '../Dollars/Dollars'
import Error from '../Error/Error'
import Modal from '../Modal/Modal'
import ModifiersLoader from './Modifiers.loader'
import { useLoadTimer } from '../ReactGAUtils/ReactGAUtils'

import './ModifiersModalHelpers.css'

const ModifiersFooter = ({
  isValid,
  loading = true,
  quantity,
  price,
  onClose,
  addToCartEnabled = false,
  additionalText = ''
}) => {
  let buttonText = quantity ? `Add to Cart (${quantity})` : `Add to Cart`
  buttonText = [buttonText, additionalText].join('')

  if (addToCartEnabled) {
    return (
      <div styleName='footer'>
        <CartButton
          data-testid='add-to-cart-button'
          type='submit'
          loading={loading}
          disabled={!isValid}
          left={buttonText}
          right={<Dollars amount={price} />}
        />
      </div>
    )
  }
  return (
    <Button
      data-testid='close-modifiers-button'
      style='primary'
      onClick={onClose}
      loading={loading}
    >
      Close
    </Button>
  )
}

ModifiersFooter.propTypes = {
  isValid: PropTypes.bool,
  quantity: PropTypes.number,
  price: PropTypes.number,
  onClose: PropTypes.func,
  addToCartEnabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  additionalText: PropTypes.string
}

const LoadingModal = ({onClose}) => {
  useLoadTimer({category: 'Item Details'})
  return (
    <Modal
      loading
      footer={<ModifiersFooter loading isValid={false} addToCartEnabled={false} />}
      onClose={onClose}
    >
      <ModifiersLoader />
    </Modal>
  )
}

LoadingModal.propTypes = {
  onClose: PropTypes.func.isRequired
}

export const ErrorModal = ({ onClose, error, retry }) => (
  <Modal
    footer={<ModifiersFooter isValid={false} />}
    onClose={onClose}>
    <Error error={error} retry={retry} />
  </Modal>
)

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  error: PropTypes.object,
  retry: PropTypes.func
}

export {
  ModifiersFooter,
  LoadingModal
}
